module.exports = __webpack_public_path__ + "img/4_146.b7b0746f.png";